export default () => ({
    init() {
        const galleryThumbnails = this.$el.querySelectorAll('[x-bind="galleryThumbnail"]');
        for (const galleryThumbnail of galleryThumbnails) {
            this.galleryItems.push({
                src: galleryThumbnail.href,
                alt: galleryThumbnail.firstElementChild.alt,
                title: galleryThumbnail.firstElementChild.title,
            });
        }
        this.atBeginning = true;
    },
    open: false,
    activeItem: 0,
    galleryItems: [],
    imageWrap: {
        'x-transition:enter': 'transition ease-out duration-150',
        'x-transition:enter-start': 'opacity-0 transform scale-90',
        'x-transition:enter-end': 'opacity-100 transform scale-100',
        'x-transition:leave': 'transition ease-in duration-150',
        'x-transition:leave-start': 'opacity-100 transform scale-100',
        'x-transition:leave-end': 'opacity-0 transform scale-90',
    },
    skip: 1,
    atBeginning: false,
    atEnd: false,
    next() {
        if (this.activeItem + 1 < this.galleryItems.length) {
            this.activeItem = this.activeItem + 1;
        }
        this.atEnd = this.activeItem + 1 >= this.galleryItems.length;
        this.atBeginning = false;
    },
    prev() {
        if (this.activeItem !== 0) {
            this.activeItem = this.activeItem - 1;
        }
        this.atBeginning = this.activeItem - 1 <= 1;
        this.atEnd = false;
    },
    navButtonNext: {
        ['@click.stop']($event) {
            this.next();
        },
        [':aria-disabled']() {
            return this.atEnd;
        },
        [':tabindex']() {
            return this.atEnd ? -1 : 0;
        },
        [':class']() {
            return this.atEnd ? 'cursor-not-allowed hover:bg-azure-500' : '';
        },
        'x-transition:enter': 'transition ease-out duration-150',
        'x-transition:enter-start': 'opacity-0 transform scale-90',
        'x-transition:enter-end': 'opacity-100 transform scale-100',
        'x-transition:leave': 'transition ease-in duration-150',
        'x-transition:leave-start': 'opacity-100 transform scale-100',
        'x-transition:leave-end': 'opacity-0 transform scale-90',
    },
    navButtonPrev: {
        ['@click.stop']($event) {
            this.prev();
        },
        [':aria-disabled']() {
            return this.atBeginning;
        },
        [':tabindex']() {
            return this.atBeginning ? -1 : 0;
        },
        [':class']() {
            return this.atBeginning ? 'cursor-not-allowed hover:bg-azure-500' : '';
        },
        'x-transition:enter': 'transition ease-out duration-150',
        'x-transition:enter-start': 'opacity-0 transform scale-90',
        'x-transition:enter-end': 'opacity-100 transform scale-100',
        'x-transition:leave': 'transition ease-in duration-150',
        'x-transition:leave-start': 'opacity-100 transform scale-100',
        'x-transition:leave-end': 'opacity-0 transform scale-90',
    },
    closeButton: {
        ['@click.stop']($event) {
            this.open = false;
        },
    },
    galleryThumbnail: {
        ['@click.prevent']($event) {
            this.activeItem = [...this.$el.parentElement.parentElement.children].indexOf(this.$el.parentElement);
            this.open = true;
            this.$nextTick(() => {
                this.$focus.focus(this.atEnd ? this.$refs.navButtonPrev : this.$refs.navButtonNext);
            });
        },
    },
    galleryWrap: {
        ['x-on:keydown.arrow-right.prevent']($event) {
            this.$focus.focus(this.$refs.navButtonNext);
            this.$refs.navButtonNext.click();
        },
        ['x-on:keydown.arrow-left.prevent']($event) {
            this.$focus.focus(this.$refs.navButtonPrev);
            this.$refs.navButtonPrev.click();
        },
        ['x-on:keydown.escape.prevent']($event) {
            this.open = false;
        },
        ['@click']($event) {
            this.open = false;
        },
    },
    focusableWhenVisible: {
        'x-intersect:enter'() {
            this.$el.removeAttribute('tabindex');
        },
        'x-intersect:leave'() {
            this.$el.setAttribute('tabindex', '-1');
        },
    },
});
